const config = {
  TOKEN_KEY: 'access_token'
}

export default config;